const PREFIX = 'masha:session:';

export interface SessionDraftCache {
  answers: Record<string, string>;
  saved_at: number;
}

export function loadDraft(sessionId: number): SessionDraftCache | null {
  try {
    const raw = window.localStorage.getItem(PREFIX + sessionId);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'answers' in parsed &&
      typeof (parsed as { answers: unknown }).answers === 'object'
    ) {
      const answers = (parsed as { answers: Record<string, unknown> }).answers;
      const cleaned: Record<string, string> = {};
      for (const [k, v] of Object.entries(answers)) {
        if (typeof v === 'string') cleaned[k] = v;
      }
      const savedAtRaw = (parsed as { saved_at?: unknown }).saved_at;
      return {
        answers: cleaned,
        saved_at: typeof savedAtRaw === 'number' ? savedAtRaw : 0,
      };
    }
    return null;
  } catch {
    return null;
  }
}

export function saveDraft(sessionId: number, answers: Record<string, string>): void {
  try {
    const payload: SessionDraftCache = { answers, saved_at: Date.now() };
    window.localStorage.setItem(PREFIX + sessionId, JSON.stringify(payload));
  } catch {
    // localStorage full / unavailable; ignore — server save on "Next" still works
  }
}

export function clearDraft(sessionId: number): void {
  try {
    window.localStorage.removeItem(PREFIX + sessionId);
  } catch {
    // ignore
  }
}

const PROFILE_KEYS = new Set(['niche', 'product', 'target_audience']);

/**
 * Filter local answers to keys a_1..a_N (with N = questionsLength) plus the three
 * profile keys (niche/product/target_audience). Profile keys are passed through
 * unconditionally — the wizard's buildPayload only forwards keys that match the
 * current step list, so stale profile keys are silently dropped at submit time.
 */
export function filterAnswersInRange(
  answers: Record<string, string>,
  questionsLength: number,
): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [k, v] of Object.entries(answers)) {
    if (PROFILE_KEYS.has(k)) {
      result[k] = v;
      continue;
    }
    const m = /^a_(\d+)$/.exec(k);
    if (!m) continue;
    const n = Number(m[1]);
    if (n >= 1 && n <= questionsLength) result[k] = v;
  }
  return result;
}
